// Mirrors UT_API/Constants/PlayerStudentInfoFileTypes.SupportedFileTypes on the API side.
// Keep these in sync — the server rejects anything outside the list with a 400.
export const SUPPORTED_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'rtf', 'txt', 'ppt', 'pptx'];
export const SUPPORTED_FILE_ACCEPT = SUPPORTED_FILE_EXTENSIONS.map(ext => `.${ext}`).join(',');
export const SUPPORTED_FILE_LABEL = `Supported: ${SUPPORTED_FILE_EXTENSIONS.map(e => e.toUpperCase()).join(', ')}`;
export const SUPPORTED_FILE_DISPLAY_LABEL = 'PDF, Doc/DOCX, TXT, Max 10MB';
export const MAX_FILE_BYTES = 10 * 1024 * 1024;

export const validateFile = (file, label) => {
    if (!file) {
        return null;
    }
    const ext = file.name?.split('.').pop()?.toLowerCase() || '';
    if (!SUPPORTED_FILE_EXTENSIONS.includes(ext)) {
        return `${label} can't be a .${ext || 'unknown'} file. ${SUPPORTED_FILE_LABEL}.`;
    }
    if (file.size > MAX_FILE_BYTES) {
        return `${label} is larger than 10 MB.`;
    }
    return null;
};

export const appendIfPresent = (formData, key, value) => {
    if (value !== null && value !== undefined && value !== '') {
        formData.append(key, value);
    }
};

// The `onboardingAcademics` context on the API replaces the record with
// whatever fields the payload carries — anything absent is cleared to null.
// Callers uploading only a transcript or resume must still re-send the
// scalar academic fields so they aren't wiped, so this helper builds that
// preserved-scalar prefix in one place.
export const appendPreservedAcademics = (formData, studentInfo) => {
    if (!studentInfo) {
        return;
    }
    appendIfPresent(formData, 'highSchoolGpa', studentInfo.highSchoolGpa);
    appendIfPresent(formData, 'coursework', studentInfo.coursework);
    appendIfPresent(formData, 'majorOfInterest', studentInfo.majorOfInterest);
    appendIfPresent(formData, 'scores.sat', studentInfo.scores?.sat);
    appendIfPresent(formData, 'scores.act', studentInfo.scores?.act);
    appendIfPresent(formData, 'scores.toefl', studentInfo.scores?.toefl);
};
